import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  ontarioLease: generateApiPath({ prefix: AuthLevel.AUTH, name: 'ontario-lease' }),
}

export { paths }
